module.exports = "../content/987989eb0ae98d2ab4131d6ae3af1b86.woff2";